import { Button, CompareIcon } from '@iheartjane/reefer';
import type { MarginProperties } from '@iheartjane/reefer';

import { useCompare } from './compareProvider';

export const CompareButton = (marginProps: MarginProperties) => {
  const { enabled, isActive, toggleActive } = useCompare();

  if (!enabled) return null;

  return (
    <Button
      {...marginProps}
      variant={isActive ? 'primary' : 'tertiary'}
      startIcon={<CompareIcon size="sm" />}
      label={isActive ? 'Done' : 'Compare'}
      onClick={toggleActive}
      aria-label={isActive ? 'Exit compare mode' : 'Enter compare mode'}
      aria-pressed={isActive}
      data-testid="compare-button"
    />
  );
};
